module.exports = __webpack_public_path__ + "assets/img/2207.38dbe166.svg";